import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ResetPassword.css";
import click from "./assets/sounds/click.mp3";
import { useTranslation } from "react-i18next";
import frFlag from "./assets/fr.png";
import enFlag from "./assets/en.png";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const API_URL = process.env.REACT_APP_API_URL;

  const handleReset = async () => {
    try {
      const res = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, newPassword, lang: i18n.language }),
      });

      const data = await res.json();
      if (!res.ok) {
        const text = await res.text();
        console.error("Erreur serveur :", text);
        setError(t("errors.serverError"));
        return;
      }

      setMessage(data.message || t("reset.resetok"));
      setError("");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      setError(err.message);
      setMessage("");
    }
  };

    const playSound = (sound) => {
    const audio = new Audio(sound);
    audio.play();
    };

    const {t, i18n} = useTranslation();
    
      const changeLang = (lang) => {
        i18n.changeLanguage(lang);
        localStorage.setItem("lang", lang);
      };

  return (
    <div className="reset-container">
      <div className="reset-box">
        <h2>{t("reset.reset")}</h2>
        <input
          type="password"
          placeholder={t("reset.new")}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        {error && <p className="error-msg">{error}</p>}
        {message && <p className="info-msg">{message}</p>}
        <button className="reset-btn" onClick={() => {playSound(click);handleReset()}}>
          {t("reset.change")}
        </button>
        <button className="back-btn" onClick={() => {playSound(click);navigate("/")}}>
          ←
        </button>
      </div>
      <div className="lang-switch">
            <img src={frFlag} alt="FR" onClick={() => changeLang("fr")} />
            <img src={enFlag} alt="EN" onClick={() => changeLang("en")} />
          </div>
    </div>
    
  );
}
